import "./login.css";
import { useEffect, useContext, useRef } from "react";
import { loginCall } from "../../apiCalls";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack"
// import { CircularProgress } from '@mui/material';

export default function Login() {
  const email = useRef();
  const password = useRef();
  const { user, isFetching, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  
  const handleClick = async (e) => {
    e.preventDefault();
    const res = await loginCall(
      { email: email.current.value, password: password.current.value },
      dispatch
    );
    enqueueSnackbar(res, {
      variant: "error",
      autoHideDuration: 3000,
    });
  };

  return (
    <>
      <div className="loginWrapper">
        <div className="loginLeft">
          <h3 className="loginLogo">Conexus</h3>
          <span className="loginDesc">
            Connect with friends and the world around you on Conexus.
          </span>
        </div>
        <div className="loginRight">
          <form className="loginBox" onSubmit={handleClick}>
            <h1 className="loginHeader">Login</h1>
            <input
              placeholder="Email"
              type="email"
              className="loginInput"
              ref={email}
              required
            />
            <input
              placeholder="Password"
              type="password"
              className="loginInput"
              minLength={6}
              maxLength="20"
              ref={password}
              required
            />
            <button className="loginButton blue buttonSfx">
              <span>Log in</span>
            </button>
            <span className="loginForgot">Forgot Password?</span>
            <button
              type="button"
              onClick={() => {
                navigate("../register");
              }}
              className="loginRegisterButton green buttonSfx"
            >
              <span>
                {isFetching
                  ? "loading" // <CircularProgress color="white" size="20px" />
                  : "Create an account"}
              </span>
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
